<template>
  <v-navigation-drawer
    v-model="drawer"
    :rail="$vuetify.display.smAndUp ? rail : null"
    :permanent="$vuetify.display.smAndUp"
    :temporary="!$vuetify.display.smAndUp"
    @click="$vuetify.display.smAndUp ? (rail = false) : null"
    width="288"
    class="sidebar"
  >
    <!-- Flex wrapper to push Sign Out to bottom -->
    <div class="sidebar-inner">
      <!-- ── Logo ── -->
      <div class="sidebar-header px-4 pt-5 pb-3">
        <div class="d-flex align-center" style="gap: 14px">
          <div class="sidebar-logo-box">
            <img
              src="../../assets/img/internLink_logo.png"
              alt="InternLink"
              width="36"
              height="36"
              style="object-fit: contain"
            />
          </div>
          <div>
            <div class="sidebar-brand">InternLink</div>
            <div class="sidebar-brand-sub">OJT Management System</div>
          </div>
        </div>
      </div>

      <!-- ── Current Role ── -->
      <div class="px-3 pt-2 pb-2">
        <!-- OJT Coordinator: role switcher dropdown -->
        <template v-if="isOjtCoordinatorOrProgChair">
          <v-menu v-model="roleMenuOpen" :close-on-content-click="true">
            <template #activator="{ props }">
              <div
                v-bind="props"
                class="role-section role-section--clickable rounded-xl d-flex justify-space-between align-center"
              >
                <div>
                  <div class="role-label">SWITCH ROLE</div>
                  <div class="role-name">{{ getMyUsertype }}</div>
                </div>
                <v-icon size="18" color="#10b981">
                  {{ roleMenuOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                </v-icon>
              </div>
            </template>

            <v-list rounded="lg" min-width="210" class="pa-1">
              <v-list-item
                v-for="role in userRoles"
                :key="role.id"
                rounded="lg"
                class="role-menu-item"
                :active="getActiveRole == role.id"
                color="#10b981"
                @click="switchRole(role.id)"
              >
                <template #prepend>
                  <v-icon
                    size="18"
                    :color="getActiveRole == role.id ? '#10b981' : '#6b7280'"
                    >mdi-account-circle-outline</v-icon
                  >
                </template>
                <v-list-item-title class="role-menu-title">
                  {{ role.description }}
                </v-list-item-title>
                <template #append>
                  <v-icon
                    v-if="getActiveRole == role.id"
                    size="15"
                    color="#10b981"
                  >
                    mdi-check
                  </v-icon>
                </template>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <!-- All other roles: static display -->
        <template v-else>
          <div
            class="role-section rounded-xl d-flex justify-space-between align-center"
          >
            <div>
              <div class="role-label">CURRENT ROLE</div>
              <div class="role-name">{{ getMyUsertype }}</div>
            </div>
            <div class="role-dot"></div>
          </div>
        </template>
      </div>

      <!-- ── Nav Items ── -->
      <v-list
        nav
        class="sidebar-nav px-4 py-2 flex-grow-1"
        style="overflow-y: auto"
      >
        <template v-for="(link, i) in links" :key="link.id">
          <!-- Flat item -->
          <v-list-item
            v-if="!link.subLink"
            :to="`/${userType}${link.route}`"
            router
            class="nav-item rounded-lg mb-1"
            :ripple="false"
          >
            <template #prepend>
              <v-icon class="nav-icon" size="20">{{ link.icon }}</v-icon>
            </template>
            <v-list-item-title class="nav-title">{{
              link.title
            }}</v-list-item-title>
            <template #append>
              <span class="nav-active-dot"></span>
            </template>
          </v-list-item>

          <!-- Group item -->
          <v-list-group v-else v-model="openGroups[i]">
            <template #activator="{ props }">
              <v-list-item
                v-bind="props"
                class="nav-item rounded-lg mb-1"
                :ripple="false"
              >
                <template #prepend>
                  <v-icon class="nav-icon" size="20">{{ link.icon }}</v-icon>
                </template>
                <v-list-item-title class="nav-title">{{
                  link.title
                }}</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item
              v-for="sublink in link.subLink"
              :key="sublink.title"
              :to="`/${userType}${sublink.route}`"
              router
              class="nav-item nav-subitem rounded-lg mb-1"
              :ripple="false"
            >
              <v-list-item-title class="nav-title nav-sub-title">{{
                sublink.title
              }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <!-- ── Sign Out (pinned to bottom) ── -->
      <div class="sidebar-footer mt-auto">
        <v-divider class="pt-2" />
        <div
          @click="logoutUser"
          class="signout-btn d-flex align-center px-4 py-3 mx-2 rounded-lg mb-2"
        >
          <v-icon start>mdi-logout</v-icon>
          <span class="signout-text"> Sign Out</span>
        </div>
      </div>
    </div>
    <!-- end sidebar-inner -->
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "NavbarPage",
  data() {
    return {
      drawer: true,
      rail: false,
      selectedDate: new Date().toISOString().substr(0, 10),
      uname: null,
      mini: false,
      profImg: null,
      mobile: false,
      isActiveOIC: false,
      userRoleList: [],
      userRoles: [],
      roleMenuOpen: false,
      links: [],
      userType: null,
      openGroups: [],
      notif_cnt: 0,
      showAllNotifDialog: false,
      interval: null,
      loading: false,
      options: [],
      activeGroup: null,
      schooYearList: [],
      selectedFiter: null,
      filterYears: [],
      notifTab: 0,
    };
  },

  watch: {
    getActiveRole: {
      handler(newData, oldData) {
        if (oldData != newData) {
          console.log("WATCH", oldData != newData, oldData, newData);
          this.loadMenu(this.$store.state.user.user.usertypeID, newData);
        }
      },
    },
  },

  computed: {
    getActiveRole() {
      let role = 0;

      if (this.$store.state.user.user.usertypeID == 3) {
        role = this.$store.getters.getActiveRole;
      }

      // if (this.$store.state.user.user.usertypeID == 4) {
      //   role = this.$store.getters.getActiveRole;
      // }

      if (this.$store.state.user.user.usertypeID == 10) {
        role = this.$store.getters.getActiveRole;
      }

      return role;
    },

    isOjtCoordinatorOrProgChair() {
      return [3, 10].includes(this.$store.state.user.user.usertypeID);
    },

    getMyUsertype() {
      const userType = this.$store.state.user.user.usertypeID;
      const roleMap = {
        1: "Superadmin",
        2: "Admin",
        4: "OJT Instructor",
        5: "Dean",
        6: "VPAA",
        7: "HTE Organization",
        8: "Student",
        9: "Field Officer",
        10: "Program Chairperson",
      };
      if (userType == 3) {
        return this.getActiveRole == 1 ? "OJT Coordinator" : "OJT Instructor";
      } else if (userType == 10) {
        if (this.getActiveRole == 10) {
          return "Program Chairperson";
        } else if (this.getActiveRole == 1) {
          return "OJT Coordinator";
        } else {
          return "OJT Instructor";
        }
        // return this.getActiveRole == 10
        //   ? "Program Chairperson"
        //     ? this.getActiveRole == 1
        //     : "OJT Coordinator"
        //   : "OJT Instructor";
      }
      return roleMap[userType] || "";
    },
  },

  mounted() {
    const { fname, lname } = this.$store.state.user;
    if (this.$store.state.user.user.usertypeID != 7) {
      if (this.$store.state.user.user.usertypeID == 9) {
        let { officer_name } = this.$store.state.user;
        this.uname = officer_name;
      } else {
        this.uname = fname + " " + lname;
      }
    } else {
      const { name } = this.$store.state.user;
      this.uname = name;
    }
  },

  methods: {
    switchRole(id) {
      this.$store.dispatch("setActiveRole", id);
    },

    getMyRole(id) {
      const match = this.userRoleList.find(
        (r) => parseInt(r.id) === parseInt(id),
      );
      return match ? match.description : "";
    },

    setSmNavIconVal() {
      this.$store.state.smNavIconOpen = true;
    },

    logoutUser() {
      this.logout();
      location.reload();
    },

    closeNav() {
      this.drawer = false;
      this.$emit("closeNav");
    },

    loadMenu(userType, user_role) {
      console.log("MENU", userType, user_role);
      this.openGroups = this.links.map((link) => !!link.subLink && false);
      const endpoint = !user_role
        ? "/assigned-modules/getMyAssignedModules/my"
        : "/assigned-modules/getModules/byRole/" + user_role;

      this.axiosCall(endpoint, "GET").then((resp) => {
        let parsedLinks = JSON.parse(resp.data.assign_mods);
        // Module route moved into Settings tab for coordinators
        if (userType == 3) {
          parsedLinks = parsedLinks.filter((l) => l.route !== "/module");
        }
        this.links = parsedLinks;
        const typeMap = {
          1: "superadmin",
          2: "admin",
          3: "ojt-coordinator",
          4: "instructor",
          5: "dean",
          6: "vpaa",
          7: "organization",
          8: "student",
          9: "field-officer",
          10: "program-chair",
        };
        this.userType = typeMap[userType] || "student";
      });
    },
  },

  beforeUnmount() {
    clearInterval(this.interval);
  },

  created() {
    const userType = this.$store.state.user.user.usertypeID;
    const userRole = this.$store.getters.getActiveRole;
    this.loadMenu(userType, userRole);
    if (userType == 3) {
      this.axiosCall("/user-role/getMyRoles", "GET").then((res) => {
        this.userRoles = res.data;
      });
    }
    if (userType == 10) {
      this.axiosCall("/user-role/getMyRoles", "GET").then((res) => {
        this.userRoles = res.data;
        this.userRoles.unshift({ id: 10, description: "Program Chairperson" });
      });
    }
  },
};
</script>

<style scoped>
/* === Sidebar wrapper === */
.sidebar {
  border-right: 1px solid #e5e7eb !important;
}

/* Full-height flex column inside the drawer */
.sidebar-inner {
  /* padding: 0 5px 0 5px; */
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* === Logo area === */
.sidebar-header {
  flex-shrink: 0;
}

.sidebar-logo-box {
  width: 56px;
  height: 56px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  padding: 10px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sidebar-brand {
  font-size: 19px;
  font-weight: 800;
  color: #1a1f2e;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.sidebar-brand-sub {
  font-size: 11.5px;
  font-weight: 500;
  color: #8d95a3;
  letter-spacing: 0.1px;
  line-height: 1.4;
  margin-top: 1px;
}

/* === Current Role === */
.role-section {
  background-color: #f0fdf4;
  padding: 10px 15px 10px 20px;
  /* border: 1px solid #d1fae5; */
}

.role-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #6b7280;
  text-transform: uppercase;
}

.role-name {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.2px;
}

.role-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #10b981;
  box-shadow: 0 0 0 3px #d1fae5;
  flex-shrink: 0;
  align-self: center;
}

/* Clickable variant */
.role-section--clickable {
  cursor: pointer;
  transition: background 0.15s;
}

.role-section--clickable:hover {
  background-color: #d1fae5 !important;
}

.role-menu-item {
  min-height: 40px !important;
}

.role-menu-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

/* === Nav items === */
.sidebar-nav {
  flex: 1;
}

.nav-item {
  min-height: 44px !important;
  padding: 0 12px !important;
  transition: background 0.15s;
}

.nav-item:hover {
  background: #f9fafb !important;
}

/* Active state */
.nav-item.v-list-item--active {
  background: #f0fdf4 !important;
  color: #16a34a !important;
}

.nav-item.v-list-item--active .nav-icon {
  color: #16a34a !important;
  opacity: 1;
}

.nav-item.v-list-item--active .nav-title {
  color: #16a34a !important;
  font-weight: 700;
}

/* Show dot only on active item */
.nav-active-dot {
  display: none;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #16a34a;
  flex-shrink: 0;
}

.nav-item.v-list-item--active .nav-active-dot {
  display: block;
}

.nav-icon {
  color: #4b5563;
  opacity: 1;
}

/* Tighten the gap between icon and label */
.nav-item :deep(.v-list-item__prepend) {
  margin-inline-end: 0;
  padding-inline-end: 10px;
  width: 28px;
}

.nav-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  letter-spacing: -0.1px;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 1.35;
}

/* Subitems */
.nav-subitem {
  padding-left: 44px !important;
}

.nav-sub-title {
  font-size: 13px;
  color: #6b7280;
}

/* === Sign Out === */
.sidebar-footer {
  flex-shrink: 0;
}

.signout-btn {
  cursor: pointer;
  color: grey;
  transition: background 0.15s;
}

.signout-btn:hover {
  background: #f3f4f6;
}

.signout-text {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
}
</style>
